import AppTabs from 'general/components/AppTabs';
import AppColors from 'general/constants/AppColors';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import NotificationCampaignTabView from '../../components/NotificationCampaignTabView';
import NotificationConfigTabView from '../../components/NotificationConfigTabView';
import SystemNotificationTabView from '../../components/SystemNotificationTabView';

const notificationCampaignEnabled = process.env.REACT_APP_NOTIFICATION_CAMPAIGN_ENABLED === 'true';

PushNotificationListScreen.propTypes = {
  agencyId: PropTypes.string,
};

function PushNotificationListScreen(props) {
  // MARK: ---- PROPERTIES ----
  const { agencyId } = props;
  const { t } = useTranslation();
  const router = useRouter();

  const tabs = useMemo(() => {
    const availableTabs = ['Thông báo thủ công', 'Thông báo hệ thống'];
    if (notificationCampaignEnabled) availableTabs.push('Thông báo tự động');
    return availableTabs.reverse();
  }, []);
  const [selectedTab, setSelectedTab] = useState(t('Thông báo thủ công'));
  const hash = router?.location?.hash;
  useEffect(() => {
    if (hash === '#notification-config') setSelectedTab('Thông báo thủ công');
    if (hash === '#system-notification') setSelectedTab(t('Thông báo hệ thống'));
    if (notificationCampaignEnabled && hash === '#notification-campaign') {
      setSelectedTab('Thông báo tự động');
    }
  }, [hash]);

  const notificationConfigTabView = useMemo(() => {
    return (
      <NotificationConfigTabView />
    );
  }, []);

  const campaignTabView = useMemo(() => {
    return (
      <NotificationCampaignTabView />
    );
  }, []);

  const systemNotificationTabView = useMemo(() => {
    return (
      <SystemNotificationTabView />
    );
  }, []);

  // MARK: ---- METHODS ----

  const handleSelectedTab = (newTab) => {
    if (selectedTab === newTab) return;
    if (newTab === 'Thông báo thủ công') {
      router.navigate('#notification-config');
    }
    if (newTab === 'Thông báo hệ thống') {
      router.navigate('#system-notification');
    }
    if (newTab === 'Thông báo tự động') {
      router.navigate('#notification-campaign');
    }
    setSelectedTab(newTab);
  };

  return (
    <div className='px-4'>
      <div className="pt-0">
        <AppTabs
          tabs={tabs}
          activeTab={selectedTab}
          handleClick={handleSelectedTab}
          className="mt-3 mr-3"
          additionalClassName=""
        />
        <div
          className="bg-white shadow"
          style={{
            borderLeft: `1px solid ${AppColors.gray[300]}`,
            borderRight: `1px solid ${AppColors.gray[300]}`,
            borderBottom: `1px solid ${AppColors.gray[300]}`,
            borderRadius: '0px 10px 10px 10px',
          }}
        >
          <>
            <div
              key={selectedTab}
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -10, opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              {selectedTab == 'Thông báo thủ công' && (
                <div className="py-4">{notificationConfigTabView}</div>
              )}
              {notificationCampaignEnabled && selectedTab == 'Thông báo tự động' && (
                <div className="py-4">{campaignTabView}</div>
              )}
              {selectedTab == 'Thông báo hệ thống' && (
                <div className="pb-3 pt-4">{systemNotificationTabView}</div>
              )}
            </div>
          </>
        </div>
      </div>
    </div>
  );
}

export default PushNotificationListScreen;
